<template>
  <div>
    <el-row type="flex" justify="space-between" :gutter="10">
      <el-col :span="12">
        <el-input v-model.number="top">
          <template slot="prepend">{{$t('components.imgLocationInputFromTop')}}</template>
        </el-input>
      </el-col>
      <el-col :span="12">
        <el-input v-model.number="left">
          <template slot="prepend">{{$t('components.imgLocationInputFromLeft')}}</template>
        </el-input>
      </el-col>
    </el-row>
    <el-link
      type="primary"
      icon="el-icon-location"
      :underline="false"
      @click="dialogVisible = true"
    >
      {{$t('components.imgLocationInputPictureAnnotation')}}
    </el-link>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <ImageContainer
        :imageUrl="imageUrl"
        :markers="markers"
        @image-click="handleImageClick"
      >
      </ImageContainer>
    </el-dialog>
  </div>
</template>

<script>
import ImageContainer from '@/components/common/ImageContainer';

export default {
  model: {
    prop: 'location',
    event: 'change',
  },
  props: {
    location: {
      type: Object,
      required: true,
    },
    imageUrl: {
      type: String,
    },
  },
  components: {
    ImageContainer,
  },
  data() {
    const top = (this.location && this.location.top) || 0;
    const left = (this.location && this.location.left) || 0;
    return {
      dialogVisible: false,
      top,
      left,
    };
  },
  computed: {
    dialogTitle() {
      const { top, left } = this;
      if (top && left) {
        return `${this.$t('components.imgLocationInputPictureAnnotation')}，${this.$t('components.imgLocationInputFromTop')}：${top}，${this.$t('components.imgLocationInputFromLeft')}：${left}`;
      }
      return this.$t('components.imgLocationInputPictureAnnotation');
    },
    markers() {
      const { top, left } = this;
      return [
        { top, left, id: this.$t('components.imgLocationInputPoint') },
      ];
    },
  },
  watch: {
    top() {
      this.emitChange();
    },
    left() {
      this.emitChange();
    },
    location() {
      const top = (this.location && this.location.top) || 0;
      const left = (this.location && this.location.left) || 0;
      this.top = top;
      this.left = left;
    },
  },
  methods: {
    emitChange() {
      const { top, left } = this;
      this.$emit('change', { top, left });
    },
    handleImageClick({ top, left }) {
      this.top = top;
      this.left = left;
    },
  },
};
</script>
